import {Component, inject, OnDestroy} from '@angular/core';
import {interval, Subscription} from 'rxjs';
import {MaintenanceService} from '../../shared/services/maintenance.service';

@Component({
  imports: [],
  selector: 'cov-maintenance',
  templateUrl: './maintenance.component.html',
})
export class MaintenanceComponent implements OnDestroy {
  private timer?: Subscription;
  private maintenanceService = inject(MaintenanceService);
  private refreshTime: number = 1000 * 60;

  constructor() {
    this.startCountdown();
  }

  private startCountdown(): void {
    this.timer = interval(this.refreshTime).subscribe(() => {
      this.maintenanceService.checkMaintenance().subscribe((maintenance) => {
        if (!maintenance) {
          window.location.reload();
        }
      });
    });
  }

  ngOnDestroy() {
    this.timer?.unsubscribe();
  }
}
